import { createContext, useContext } from "react";

interface ContextProps {
  articleId: string;
  previewParam: string | undefined | null;
  primaryCategorySlug: string;
}

type ProviderProps = ContextProps & {
  children: React.ReactNode;
};

const ArticleContext = createContext<ContextProps>({
  articleId: "",
  previewParam: "",
  primaryCategorySlug: "",
});

export const ArticleContextProvider = ({
  articleId,
  previewParam,
  primaryCategorySlug,
  children,
}: ProviderProps) => {
  return (
    <ArticleContext.Provider
      value={{ articleId, previewParam, primaryCategorySlug }}
    >
      {children}
    </ArticleContext.Provider>
  );
};

export const useArticleContext = () => {
  const context = useContext(ArticleContext);
  if (context === undefined)
    throw new Error("useContext must be used within a Provider");
  return context;
};
